import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import TerminalIcon from '@mui/icons-material/Terminal';

interface DebugFabProps {
  onClick: () => void;
}

const DebugFab: React.FC<DebugFabProps> = ({ onClick }) => {
  return (
    <Tooltip title="Open Debug Panel" placement="left">
      <Fab
        color="primary"
        size="medium"
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1100,
          bgcolor: 'grey.700',
          '&:hover': {
            bgcolor: 'grey.800',
          },
        }}
        data-testid="debug-panel-fab"
      >
        <TerminalIcon />
      </Fab>
    </Tooltip>
  );
};

export default DebugFab;
